var render = function render(_c,_vm){return _c('div',{class:['base-logo', _vm.props.theme]},[(_vm.props.small)?_c('img',{attrs:{"src":require("../assets/img/logo/LOGO_B_TAP.png")}}):_c('img',{attrs:{"src":require("../assets/img/logo/LOGO_B_SMALL.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }